<script>
import simplebar from "simplebar-vue";

import OrdersApi from "@/services/orders-api";

export default {
        components: { simplebar  },
mounted(){
    this.getTotalSales()
    this.getTopTenItems()
  },
  data() {
    return {
      itemsList:[],
      total:null,
    };
  },


  methods: {
    getTopTenItems(){
        OrdersApi.getTopTenItems().then(
            (result) => {
                this.itemsList=result;
            }
        )
    },

    getTotalSales(){
        OrdersApi.getTotalSales().then(
            (result)=>{
                this.total=result
            }
        )
    }
}
}

</script>
<template>
<div class="card border border-light mt-2 mb-2">
    <div class="card-body p-0" style="min-height:550px;">
        <div class="clearfix m-4">
            <h4 class="card-title mb-2 font-size-18 text-primary">TOP 10 des Articles<span class="font-size-12"> (HT)</span></h4>
            <div v-if="itemsList.length" class="text-center" >
              <div class="mb-2 mt-4 ">
                <i class="bx bx-star text-success display-4" style="font-size: 36px"></i>
              </div>
              <span class="text-success mb-1" style="font-size:20px">{{itemsList[0].itemTitle}}</span>
              <h3>{{itemsList[0].sumAsString}} TND</h3>
            </div>

            <div class="table-responsive mt-4" >
                <simplebar >
                    <table class="table table-centered" >
                        <tbody>
                            <tr v-for="item in itemsList" :key="item.itemTitle">
                                <td v-if="total!=null && total!=0 && item.sum!=0" style="width: 150px">
                                    <p class="mb-0">{{item.itemTitle}}</p>
                                </td>
                                <td v-if="total!=null && total!=0 && item.sum!=0" style="width: 130px">
                                    <h5 class="mb-0">{{item.sumAsString}} TND</h5>
                                </td>
                                <td v-if="total!=null && total!=0 && item.sum!=0" style="width: 190px">
                                    <b-progress 
                                    :value="item.sum/total * 100" 
                                    variant="success" 
                                    height="15px" 
                                    show-value>
                                    </b-progress>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </simplebar >
            </div>
        </div>

        </div>
    </div>
</template>
